import React, { useEffect, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";

export default function AcknowledgementForm({ setValues, values }) {

    const signatureRef = useRef();

    const handleSave = () => {
        const imageDataUrl = signatureRef.current.toDataURL();
        setValues({ ...values, signature: imageDataUrl });
    };

    const handleClear = () => {
        signatureRef.current.clear();
        setValues({ ...values, signature: "" });
    };

    function HandleChange(e) {
        setValues({ ...values, [e.target.name]: e.target.value });
    }

    function normalizeLabel(key) {
        return key
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, str => str.toUpperCase())
            .trim();
    }

    const customLabels = {
        businessName: "Business Name (Optional)",
        IDNum: "ID Number / Business Reg",
        name: "Signer Name",
        email: "Email Address",
        address: "Business Address",
        day: "Collection Day"
    };

    const renderField = (key) => {

        if (key === "signature") return null;

        if (key === "title") {
            return (
                <select
                    key={key}
                    name={key}
                    value={values[key]}
                    onChange={HandleChange}
                    style={{ display: "block", marginBottom: 10 }}
                >
                    <option value="">Select Title</option>
                    <option value="Mr.">Mr.</option>
                    <option value="Mrs.">Mrs.</option>
                    <option value="Ms.">Ms.</option>
                    <option value="Dr.">Dr.</option>
                    <option value="Prof.">Prof.</option>
                </select>
            );
        }

        if (key === "email") {
            return (
                <input
                    key={key}
                    type="email"
                    name={key}
                    placeholder={customLabels[key] || normalizeLabel(key)}
                    value={values[key]}
                    onChange={HandleChange}
                    style={{ display: "block", marginBottom: 10 }}
                />
            );
        }

        if (key === "day") {
            return (
                <input
                    key={key}
                    type="number"
                    name="day"
                    placeholder={customLabels[key]}
                    value={values.day}
                    min={1}
                    max={31}
                    onChange={(e) => {
                        const val = Number(e.target.value);
                        if (val >= 1 && val <= 31) {
                            setValues({ ...values, day: val });
                        } else if (e.target.value === "") {
                            setValues({ ...values, day: "" });
                        }
                    }}
                    style={{ display: "block", marginBottom: 10 }}
                />
            );
        }

        return (
            <input
                key={key}
                type="text"
                name={key}
                placeholder={customLabels[key] || normalizeLabel(key)}
                value={values[key]}
                onChange={HandleChange}
                style={{ display: "block", marginBottom: 10 }}
            />
        );
    };

    return (
        <div className="row">
            <div className="col" style={{ width: "100%" }}>

                {Object.keys(values).map((key) => renderField(key))}

                <br />

                <p style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                    Please sign in the area below
                </p>

                <br />

                <SignatureCanvas
                    ref={signatureRef}
                    penColor="black"
                    canvasProps={{ width: 300, height: 300, className: "sigCanvas" }}
                    onEnd={handleSave}
                />

                <br />

                <button
                    className="btn btn-danger"
                    style={{ marginRight: 25 }}
                    onClick={handleClear}
                >
                    Clear
                </button>

                {/* <button
                    className="btn btn-success"
                    onClick={handleSave}
                >
                    Save
                </button> */}

            </div>
        </div>
    );
}